import { render } from "./AdvBuy.vue?vue&type=template&id=949cea84"
import script from "./AdvBuy.vue?vue&type=script&lang=js"
export * from "./AdvBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__